import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, useEffect, useState } from "react";
import VccReverseGeocoder from "../reverse-geocoder";

const useStyles = makeStyles(() => ({
  legendContainer: {
    display: "flex",
    justifyContent: "center",
    bottom: "0",
    position: "absolute",
    marginBottom: "75px",
    zIndex: 1,
  },
}));

interface EventLocationControlPanelProps {
  props: {
    selectedLatLong?: { latitude: number; longitude: number };
    handleCancel: () => void;
    handleConfirm: (latitude: number, longitude: number, address: string) => void;
  };
}

const EventLocationControlPanel: FC<EventLocationControlPanelProps> = ({ props }) => {
  const classes = useStyles();
  const [initialLatLong, setInitialLatLong] = useState({} as { latitude: number; longitude: number });
  const [saveDisabled, setSaveDisabled] = useState(true);

  useEffect(() => {
    if (props.selectedLatLong) {
      setInitialLatLong({ latitude: props.selectedLatLong.latitude, longitude: props.selectedLatLong.longitude });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      initialLatLong.latitude === props.selectedLatLong?.latitude &&
      initialLatLong.longitude === props.selectedLatLong?.longitude
    ) {
      setSaveDisabled(true);
    } else {
      setSaveDisabled(false);
    }
  }, [initialLatLong, props.selectedLatLong?.latitude, props.selectedLatLong?.longitude]);

  const handleCancel = () => {
    props.handleCancel();
  };

  const handleUseLocation = () => {
    setSaveDisabled(true);
    props.handleConfirm(0, 0, "");
  };

  return (
    <Box component={Paper} m={1} mb={6} ml={7} className={classes.legendContainer}>
      <Grid container>
        <Grid item xs={12}>
          <Box m={1}>
            <Typography variant={"h6"}>Set Construction or Event Location</Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box m={1}>
            <Typography variant={"body1"}>
              Click a location on the map to set a new Construction or Event Location
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box m={1}>
            <VccReverseGeocoder
              props={{
                latLong: { latitude: props.selectedLatLong?.latitude, longitude: props.selectedLatLong?.longitude },
                isEdit: true,
                handleUpdateTextAddress: () => {},
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box m={1}>
            <Divider />
          </Box>
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end" alignItems="flex-end">
          <Grid item>
            <Box m={1}>
              <Button variant="contained" color="inherit" size="small" onClick={handleCancel}>
                Cancel
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box m={1}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                disabled={saveDisabled}
                onClick={handleUseLocation}
              >
                Use Selected Location
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EventLocationControlPanel;
